import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiCallService } from "src/app/api/service/api-call.service";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import { ValidationService } from "src/app/services/validation.service";
import { environment } from "src/environments/environment";
import * as Constants from "../../../../../constant/Constants";

@Component({
  selector: "app-page2",
  templateUrl: "./page2.component.html",
  styleUrls: ["./page2.component.css"],
})
export class Page2Component implements OnInit {
  // Url Params
  claim: string = "own"; // own, flood, fire ... etc.
  id: string = "none";
  token: string = "placeholder-value"; // to validate the public accesses.
  // +++++++++++

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  RoadSurfaces: any = [
    "TARMAC",
    "MURRAM"
  ];
  VisibilityOptions: any = [
    "CLEAR",
    "POOR"
  ];
  WeatherOptions: any = [
    "RAINY",
    "SUNNY",
    "CLOUDY"
  ];

  pageHeading: string = "Claim Form";
  pageHeadingSuffix: string = " Claim Form (Continued)";
  pageSubheading: string = "Enter Accident details";

  accidentDateLabel: string = "Date of accident";
  accidentTimeLabel: string = "Time of accident";
  accidentLocationLabel: string = "Location of accident";
  vehicleInUseQuestion: string = "Was the vehicle in use at the time of the incident?";
  roadSurfaceLabel: string = "Type of road surface";
  accidentSpeedLabel: string = "Estimated speed before accident";
  visibilityLabel: string = "Visibility";
  lightsShowingLabel: string = "What lights were showing on the vehicle?";
  driverWarningLabel: string = "What warning did your driver give?";
  weatherLabel: string = "What were the weather conditions?";
  purposeAccidentLabel: string =
    "What purpose was the vehicle being used for at time of accident?";

  policeInfoSubheading: string = "Police Info";
  policeQuestion: string = "Did the police take particulars?";

  yesText: string = "Yes";
  noText: string = "No";

  constableNumLabel: string = "Enter Constable's number (optional)";
  policeStationLabel: string = "Enter Police Station";
  driverStatementLabel: string = "Please give the driver's statement";
  ownerStatementLabel: string =
    "Please enter the owner's or policy holder's statement";

  cancelText: string = "Cancel";
  saveText: string = "Save and Continue";

  minDate: Date;
  maxDate: Date;

  requiredString: string = "This field is required";

  motorForm = this._formBuilder.group({
    accidentDate: ["",Validators.required],
    accidentTime: ["",Validators.required],
    accidentLocation: ["",Validators.required],

    vehicleInUse: this._formBuilder.group({
      yes: false,
      no: true,
    }),

    roadSurface: [""],
    accidentSpeed: [""],
    visibility: [""],
    lightsShowing: [""],
    driverWarning: [""],
    weather: [""],
    purposeAccident: [""],

    policeTookParticulars: this._formBuilder.group({
      yes: false,
      no: true,
    }),

    constableNum: [""],
    policeStation: [""],
    driverStatement: [""],
    ownerStatement: [""],
  });
  formGroupErrors: { [key: string]: string } = {
    policeTookParticulars: "",
    vehicleInUSe: "",
  };
  formErrors: { [key: string]: string } = {
    accidentDate: "",
    accidentTime: "",
    accidentLocation: "",
    roadSurface: "",
    accidentSpeed: "",
    visibility: "",
    lightsShowing: "",
    driverWarning: "",
    weather: "",
    purposeAccident: "",
    constableNum: "",
    policeStation: "",
    driverStatement: "",
    ownerStatement: "",
  };
  validationMessages: { [key: string]: { [key: string]: string } } = {
    accidentDate: { required: this.requiredString },
    accidentTime: { required: this.requiredString },
    accidentLocation: { required: this.requiredString },
    vehicleInUse: { required: this.requiredString },
    roadSurface: { required: this.requiredString },
    accidentSpeed: { required: this.requiredString },
    visibility: { required: this.requiredString },
    lightsShowing: { required: this.requiredString },
    driverWarning: { required: this.requiredString },
    weather: { required: this.requiredString },
    purposeAccident: { required: this.requiredString },
    constableNum: { required: this.requiredString },
    policeStation: { required: this.requiredString },
    driverStatement: { required: this.requiredString },
    ownerStatement: { required: this.requiredString },
    policeTookParticulars: { required: this.requiredString },
  };

  url: string = environment.baseUrl + Constants.claimExtraDetailsURL;

  loading: boolean = false;

  constructor(
    private router: Router,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private validationService: ValidationService,
    public dialog: MatDialog,
    private apiCallService: ApiCallService,
  ) {
    const currentDate = new Date();
    const tempDate = new Date(currentDate.getTime());

    tempDate.setFullYear(currentDate.getFullYear() - 10);

    this.minDate = tempDate;
    this.maxDate = currentDate;
  }

  ngOnInit(): void {
    this.motorForm.valueChanges.subscribe((form) => {
      this.logErrors();

      if (form.accidentLocation) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          accidentLocation: form.accidentLocation.replace(/[^\w\s\d]/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }

      if (form.roadSurface) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          roadSurface: form.roadSurface.replace(/[^\w\s\d]/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }

      if (form.accidentSpeed) {
        this.motorForm.patchValue({
          accidentSpeed: form.accidentSpeed.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }

      if (form.visibility) {
        this.motorForm.patchValue({
          // First replace: remove strings, 2nd replace: leading zeros
          visibility: form.visibility.replace(/[^\w\s\d]/g, '').replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
    });

    // this.validationService.addOrRemoveValidationDependent(
    //   this.motorForm.get("policeTookParticulars.yes")!,
    //   "constableNum",
    //   this.motorForm,
    //   this.formGroupErrors,
    //   this.validationMessages
    // );
    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("policeTookParticulars.yes")!,
      "policeStation",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("policeTookParticulars.yes")!,
      "driverStatement",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.addOrRemoveValidationDependent(
      this.motorForm.get("policeTookParticulars.yes")!,
      "ownerStatement",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.subcribeToControlChanges(
      "policeTookParticulars",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );

    this.route.queryParams.subscribe((params) => {
      this.token = params["token"] !== 'undefined' ? params["token"] : Constants.tokenPlaceholderValue;

      if (params["id"] !== undefined) {
        this.id = params["id"];
      }
      if (params["claim"] !== undefined) {
        this.claim = params["claim"];

        if (this.claim === "fire" || this.claim === "flood") {
          if (this.claim === "fire") {
            this.pageHeading = "Fire Damage" + this.pageHeadingSuffix;
            this.pageSubheading = "Enter Fire Incident details";
          } else if (this.claim === "flood") {
            this.pageHeading = "Flood Damage" + this.pageHeadingSuffix;
            this.pageSubheading = "Enter Flood Incident details";
          }

          this.validationService.subcribeToControlChanges(
            "vehicleInUse",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("vehicleInUse.yes")!,
            "roadSurface",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("vehicleInUse.yes")!,
            "accidentSpeed",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("vehicleInUse.yes")!,
            "visibility",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("vehicleInUse.yes")!,
            "lightsShowing",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("vehicleInUse.yes")!,
            "driverWarning",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("vehicleInUse.yes")!,
            "weather",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
          this.validationService.addOrRemoveValidationDependent(
            this.motorForm.get("vehicleInUse.yes")!,
            "purposeAccident",
            this.motorForm,
            this.formGroupErrors,
            this.validationMessages
          );
        } else if (this.claim === "own") {
          this.pageHeading = "Own Damage/Car Damage" + this.pageHeadingSuffix;
  
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("roadSurface")!,
          );
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("accidentSpeed")!,
          );
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("visibility")!,
          );
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("lightsShowing")!,
          );
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("driverWarning")!,
          );
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("weather")!,
          );
          this.validationService.addOrRemoveValidator(
            true,
            this.motorForm.get("purposeAccident")!,
          );
        }
      }

    });
  }
  logErrors() {
    this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages
    );
  }

  onNdioChange() {
    this.motorForm.controls["vehicleInUse"].controls["no"].setValue(
      false
    );
  }

  onLaChange() {
    this.motorForm.controls["vehicleInUse"].controls["yes"].setValue(
      false
    );
  }

  onYesChange() {
    this.motorForm.controls["policeTookParticulars"].controls["no"].setValue(
      false
    );
  }

  onNoChange() {
    this.motorForm.controls["policeTookParticulars"].controls["yes"].setValue(
      false
    );
  }

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      page: 'claimData2',
      accidentDate: this.motorForm.controls["accidentDate"].value,
      accidentTime: this.motorForm.controls["accidentTime"].value,
      accidentLocation: this.motorForm.controls["accidentLocation"].value,
      vehicleInUse: this.motorForm.controls["vehicleInUse"].value,
      roadSurface: this.motorForm.controls["roadSurface"].touched ? this.motorForm.controls["roadSurface"].value : null,
      accidentSpeed: this.motorForm.controls["accidentSpeed"].touched ? this.motorForm.controls["accidentSpeed"].value : null,
      visibility: this.motorForm.controls["visibility"].touched ? this.motorForm.controls["visibility"].value : null,
      lightsShowing: this.motorForm.controls["lightsShowing"].touched ? this.motorForm.controls["lightsShowing"].value : null,
      driverWarning: this.motorForm.controls["driverWarning"].touched ? this.motorForm.controls["driverWarning"].value : null,
      weather: this.motorForm.controls["weather"].touched ? this.motorForm.controls["weather"].value : null,
      purposeAccident: this.motorForm.controls["purposeAccident"].touched ? this.motorForm.controls["purposeAccident"].value : null,
      policeTookParticulars: this.motorForm.controls["policeTookParticulars"].controls['yes'].value === true ? this.motorForm.controls["policeTookParticulars"].controls['yes'].value : false,
      constableNum: this.motorForm.controls["policeTookParticulars"].controls['yes'].value === true ? this.motorForm.controls["constableNum"].value : null,
      policeStation: this.motorForm.controls["policeTookParticulars"].controls['yes'].value === true ? this.motorForm.controls["policeStation"].value : null,
      driverStatement: this.motorForm.controls["policeTookParticulars"].controls['yes'].value === true ? this.motorForm.controls["driverStatement"].value : null,
      ownerStatement: this.motorForm.controls["policeTookParticulars"].controls['yes'].value === true ? this.motorForm.controls["ownerStatement"].value : null,
      token: this.token,
      filled: true,
    };

    try {
      // Update form data (POST)
      const response = await this.apiCallService.postRequest(
        `${this.url}?token=${this.token}`, req
      ); // url to change for UG?
      
      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        // console.log("::: Post successful :::");
        const nextToken = response.token;
        const nextPage = `/claim-details/page3`;
        // Navigate to Page 3 of claims Form
        this.router.navigate([nextPage], {queryParams: {claim: this.claim, id: this.id, token: nextToken}});
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error)
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'cancel',
        'TRY AGAIN'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
  }

  submitForm(): void {
    this.initDialogData(
      'Confirm submission',
      'Please proceed only if you have verified that the form details are correct',
      'Back',
      'Proceed'
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  confirmCancel() {
    this.initDialogData(
      'Warning',
      'Are you sure you want to cancel the application?',
      'back',
      'Cancel application'
    );

    this.showGenericPopup(this.cancelApplication);
  }

  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
        
      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Failed',
          'An error occurred while attempting to cancel your application',
          'Cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      // Navigate back to Whatsapp chat
      window.location.href = environment.whatsappRedirectURL;
    }
  }
}
